 <template>
 <div id="app">
   <component :is="layout">
     <router-view/>
  </component>
 </div>
</template>

<script>
const default_layout = 'no-sidebar'
export default {
  computed: {

    layout () {
      return (this.$route.meta.layout || default_layout) + '-layout'
    }
  }

}
</script>
<style>
.photomouse:hover{
  width: 150px;
}
 .msgWorning {

 text-align: center
}
.msgSucess {
 color:green;
 text-align: center
}
.msgError {
 color:red;
 text-align: center;
}
.formPosition {
  margin-top: 10px;

}
/* ---------- ESTILIZAÇÃO GLOBAL DA TABELA RESPONSIVA ---------- */
.tabela_responsiva_container {
  border: 1px solid rgba(0, 0, 0, 0.12);
  font-size: .8em;
  text-align: center;
  justify-content: center;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  table-layout: fixed;
  width: 100%;
}
.tabela_responsiva_th {
  border: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center;
  justify-content: center;
  background-color: #f4f4f4;
  padding: .652em;
  text-align: center;
  font-size: 1em;
  letter-spacing: .1em;
  text-transform: uppercase;
}

.tabela_responsiva_th_index {
  width: 100px;
}
.tabela_responsiva_th_full {
  border: 1px solid rgba(0, 0, 0, 0.12);
  width: 250px;
  text-align: center;
}
.tabela_responsiva_tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}
.tabela_responsiva_td {
  padding: .652em;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center;
  justify-content: center;
}

.tabela_responsiva_td_hd {
  padding: .652em;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center;
  justify-content: center;
}

.tabela_responsiva_valor_oculto {
  opacity: 0 !important;
}
.tabela_responsiva_alinhaEsquerda {
  text-align: left;
}

.tabela_responsiva_alinhaEsquerda_hd {
  text-align: left;
}

.zebra-table .v-data-table__tr:nth-child(even) {
  background-color: #f2f2f2; /* cor clara */
}
.zebra-table .v-data-table__tr:nth-child(odd) {
  background-color: white; /* cor padrão */
}

/* AJUSTAMENTO DA TABELA PARA MOBILE */
@media screen and (max-width: 800px) {
  .table-bordered {
    border: 0 !important;

  }
  .tabela_responsiva_thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .tabela_responsiva_tr {
    border: 0 !important;
    display: block;
    text-align: right;
    margin-bottom: 10px;
  }
  .tabela_responsiva_td {
    border: 0 !important;
    border-bottom: 1px solid #ddd !important;
    display: block;
    text-align: right;
    padding: 10px 3px 0 5px;
  }
  .tabela_responsiva_td_hd {
    font-size: 1.1em;
    border: 0 !important;
    border-bottom: 1px solid #ddd !important;
    font-weight: bold;
    display: block;
  }

  .tabela_responsiva_td_ft {
    border: 0 !important;
    border-bottom: 1px solid #ddd !important;
    display: block;
    text-align: right;
    padding: 10px 3px 0 5px;
  }

  .tabela_responsiva_td_ft::before {
    content: attr(data-label);
    float: left;
    font-style: italic;
    font-weight: bold;
  }


  .tabela_responsiva_td::before {
    content: attr(data-label);
    float: left;
    /* font-weight: bold; */
    /* text-transform: uppercase; */
  }
  .tabela_responsiva_td:last-child {
    border-bottom: 0;
  }
  .tabela_responsiva_esconder {
    display: none;
  }
  .tabela_responsiva_alinhaEsquerda {
    text-align: right;
  }
}
/* -------- FIM ESTILIZAÇÃO GLOBAL DA TABELA RESPONSIVA -------------- */

/* -------- ESTILIZAR GLOBAL PARA AS COMBO BOX -------------- */
.div_drop_container .div_elselect_container .elselect_tag {
  width: 170px;
  margin-right: 1px;
}
.div_drop_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
@media (max-width: 500px) {
  .div_drop_container {
    flex-direction: column;
    margin-bottom: 10px;
  }
  .div_drop_container .div_elselect_container {
    display: flex;
    flex-direction: row;
  }
  .div_drop_container .div_elselect_container .elselect_tag {
    width: 100px;
  }
}
/* -------- FIM ESTILIZAÇÃO GLOBAL DAS COMBO BOX-------------- */

.red_color_text {
  color: #ff0000 !important;
}

/* ----------- ESTILIZAÇÃO GLOBAL PARA AS PÁGINAS DE LANÇAMENTO DE NOTAS ----------------------- */
.row-back-button {
  float:right;
}
.row-span-title {
  display: block;
  margin-bottom: 5px;
}
.row-span-subtitle {
  font-weight: bold;
}
.row-span-bloqueio-red {
  color : red;
}
.row-span-bloqueio-green {
  color:green;
}
.row-nbutton-mostra {
  font-size: 13333px;
  margin-bottom: 10px; 
  float:right;
}
.cadeirantesTitleH2 {
  font-weight: bold;
  font-size: 1em;
}
.boldClasse {
  font-weight: bold !important;
}
.boldClasseMargin {
  margin-left:10px;
}

.estudante-detalhes-notas {
  display: block;
}
/* ----------- FIM ESTILIZAÇÃO GLOBAL PARA AS PÁGINAS DE LANÇAMENTO DE NOTAS ----------------------- */

/* ----------- ESTILIZAÇÃO GLOBAL PARA AS PÁGINAS DE MENÚ ----------------------- */
.menu_container_section_background {
  width: 100%;
  background-color: transparent;
  background-size: cover;
  background-position: center;
  position: relative;
  padding: 8px;
}

.menu_container_section_container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columns for mobile */
  gap: 12px;
  justify-content: center;
  align-items: stretch;
}

.menu_container_section_ {
  width: 100%;
  height: 150px; /* Altura aumentada para mobile */
  margin: 0;
  padding: 12px;
  display: flex;
  flex-direction: column; /* Imagem acima, texto abaixo */
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.menu_container_section_:hover {
  transform: translateY(-3px);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 10px 20px;
  background-color: #f8f9fa;
}

.menu_container_section_img {
  width: 80px; /* Tamanho aumentado */
  height: 80px; /* Tamanho aumentado */
  margin-bottom: 12px; /* Espaço entre imagem e texto */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 10px;
}

.photo {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
}

.menu_container_section_img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.menu_container_section_text_container {
  width: 100%;
  text-align: center;
}

.menu_container_section_text_title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #2c3e50;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.menu_container_section_text_sutitle {
  font-weight: 400;
  font-size: 0.8rem;
  color: #7f8c8d;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limita a 2 linhas */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.novo-badge-item-menu {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #0059ff;
  color: #ffffff;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  z-index: 2;
}


.novo-badge-item-menu-qrcode {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #c40b14;
  color: #ffffff;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  z-index: 2;
}

/* Tablet View */
@media (min-width: 600px) {
  .menu_container_section_ {
    height: 160px; /* Altura aumentada para tablets */
  }
  
  .menu_container_section_img {
    width: 70px;
    height: 70px;
  }
}

/* Desktop View */
@media (min-width: 960px) {
  .menu_container_section_container {
    grid-template-columns: repeat(3, 1fr); /* 3 colunas para desktop */
  }
  
  .menu_container_section_ {
    height: 180px;
  }
  
  .menu_container_section_img {
    width: 110px;
    height: 110px;
  }
  
  .menu_container_section_text_title {
    font-size: 1.05rem;
  }
}

/* Large Desktop View */
@media (min-width: 1264px) {
  .menu_container_section_container {
    grid-template-columns: repeat(3, 1fr); /* 4 colunas para telas grandes */
  }
}

/* ----------- FIM ESTILIZAÇÃO GLOBAL PARA AS PÁGINAS DE MENÚ ----------------------- */


/* ----------- ESTILIZAÇÃO GLOBAL PARA OS BUTTONS DE IMPRESSÃO ----------------------- */
.print-button {
  width: 100px ;
  font-size: 15px;
  color: #484646 !important;
  font-weight: bold !important;
  transition: all .5s ease-in-out !important;
}
.print-button:hover {
  color: #484646 !important;
}
.print-excel {
  background-color: #189e18 !important;
}
.print-pdf {
  background-color: #ec2f2f !important;
}
.print-excel:hover {
  background-color: #73de73 !important;
}
.print-pdf:hover {
  background-color: #f09a9a !important;
}

/* ----------- FIM ESTILIZAÇÃO GLOBAL PARA OS BUTTONS DE IMPRESSÃO ----------------------- */

/* ----------- ESTILIZAÇÃO GLOBAL PARA OS CABEÇALHO E LEGENDAS DAS PÁGINAS LANÇAMENTO DE NOTAS ----------------------- */
.pauta-cabecalho-container {
  display: grid;
  grid-template-columns: 150px 1fr;
  column-gap: 5px;
}
.pauta-cabecalho-container span {
  display: block;
}
.pauta-cabecalho-block-2 span {
  font-weight: bold;
}
.left-side-button {
  float: left;
}
.pauta-footer-calculo-container {
  display: grid;
  grid-template-columns: 100px 30px 1fr;
  column-gap: 5px;
}
.pauta-footer-calculo-container span {
  display: block;
}
@media (max-width: 500px) {
  .pauta-cabecalho-container {
    grid-template-columns: 100px 1fr;
  }
  .pauta-cabecalho-container span {
    font-size: 12px;
    margin-bottom: 5px;
  }
  .pauta-footer-calculo-container {
    grid-template-columns: 80px 15px 1fr;
  }
  .pauta-footer-calculo-container span {
    font-size: 10px;
    margin-bottom: 5px;
  }
}
/* ----------- FIM ESTILIZAÇÃO GLOBAL PARA OS CABEÇALHO E LEGENDAS DAS PÁGINAS LANÇAMENTO DE NOTAS ----------------------- */

.MenuCard {
  height: 180px;
  padding: 20px;
  border: 1px solid #006699;
  border-radius: 20px;
}

.MenuCard:hover {
  background-color: #413939;
  cursor: pointer;
}

#texto {
  font-size: 16px;
  font-weight: bold;
  color: #006699;
}

.MenuCard:hover #texto {
  color: white;
}

.tpaCombox {
    height: 50px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 0 5px;
}

/* Estilo do cabeçalho */
.dialog-header {
    display: flex;
    justify-content: flex-end;
    padding: 8px;
}

/* Botão de fechar */
.close-btn {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s;
}

.close-btn:hover {
    background-color: #ffeaea;
}


</style>
